import React, {useState, useEffect} from 'react';
import post from '../utils/post.js';
import {Link} from 'react-router-dom';

export default function Activate() {
	const [loading, setLoading] = useState(false);
	const [email, setEmail] = useState('');

	var code = window.location.search.split('=')[1];

	useEffect(() => {
		if (code) {
			getValidRegistrationCode();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const getValidRegistrationCode = () => {
		setLoading(true);

		post('activate', {code})
			.then((res) => {
				if (res.data !== '') {
					setEmail(res.data);
				}
				setLoading(false);
			})
			.catch((error) => {
				console.error(error);
				setLoading(false);
			});
	};

	return (
		<div className="login">
			{loading ? <div className="loading" /> : ''}

			<div className="login_shell">
				<div className="login_brand">
					<img className="login_logo" alt="" />
				</div>

				<div className="login_container auth-card auth-card--compact">
					<div className="login_container_in auth-card__body">
						<div className="auth-card__eyebrow">Aktivace</div>
						<h1 className="auth-card__title">Aktivace účtu</h1>
						{email === '' ? (
							<div className="auth-message auth-message--danger">Aktivační kód neexistuje. Prosím proveďte registraci.</div>
						) : (
							<div className="auth-message auth-message--success">Účet <strong>{email}</strong> byl aktivován.</div>
						)}

						<div className="auth-links auth-links--center">
							<Link to={'/'} key="lnk_login" className="lnk1 auth-link">
								Zpět na přihlášení
							</Link>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
